import { render, staticRenderFns } from "./NsPassword.vue?vue&type=template&id=76bc7f67&scoped=true&"
import script from "./NsPassword.vue?vue&type=script&lang=js&"
export * from "./NsPassword.vue?vue&type=script&lang=js&"
import style0 from "./NsPassword.vue?vue&type=style&index=0&id=76bc7f67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bc7f67",
  null
  
)

export default component.exports